import React, {Component} from "react";
import {inject, observer} from "mobx-react";
import "../assets/stylesheets/ClassReport.scss";
import Breadcrumb from "../components/Breadcrumb";
import List from "../components/List";
import SchoolStore from "../stores/SchoolStore";
import QrCodeModal from "../components/QrCodeModal";

import DropdownSchool from './DropdownSchool';
import DropdownClass from './DropdownClass';
import DropdownLesson from './DropdownLesson';


@inject('Navigator', 'StudentStore', 'AuthStore', 'SchoolStore')
@observer
export default class ClassReport extends Component {

    static breadcrumbSegments = [
        {
            title: "Portal do professor",
            uri: "/"
        },
        {
            title: "Histórico de presença",
            uri: ""
        }
    ]; 

    constructor(props) {
        super(props);

        this.state = {
            percentage: '0',
            students: [],
            change: false,
        }
        

        //Unset Engagament
        this.props.SchoolStore.isEngagement = false;
    }

    componentWillMount(){
        if(this.props.SchoolStore.isSearch){
            // Solicitado que as combos permanecam cos os valores quando alterna de uma pagina para outra
            // this.props.SchoolStore.students = [];
            // this.props.SchoolStore.studentsEngagement = [];
            // this.props.SchoolStore.schoolSelected   = null;
            // this.props.SchoolStore.classSelected   = null;
            // this.props.SchoolStore.lessonSelected  = null;
            this.props.SchoolStore.isSearch = false;
        }
    }
    
    handleBreadcrumbClick(uri) {
        this.props.ConfigStore.animationType = "right";
        this.props.Navigator.push(uri);
    }

    handleChangeLesson(e) {
        
        this.props.SchoolStore.getStudentsByLesson(this.props.SchoolStore.currentClass,e.id_sf);
        SchoolStore.students_store = this.props.SchoolStore.students;
    }

    handleChangeClass(e) {}

    handleChangeSchool(e) {}

    handleClickStudent(studentCpf) {
        this.props.Navigator.push(`/detail-student/${studentCpf}`);
    }

    handleClickCheckAttendance(student_id, unit_id){
        this.props.SchoolStore.checkAttendance(student_id, unit_id);
    }

    handleGenerateQRCode() {
        const { schoolSelected, classSelected, lessonSelected  } = this.props.SchoolStore;

        const unidade = schoolSelected.value;
        const id_turma = this.props.SchoolStore.classes[classSelected.value].id_sf;
        const id_atividade = this.props.SchoolStore.lessons[lessonSelected.value].id_sf;

        if (schoolSelected && classSelected && lessonSelected) {
            const qrCodeString = `${unidade}/${id_turma}/${id_atividade}`;
            this.qrModalRef.open(qrCodeString, 'QR code de presença'); 
        }
        }

    render() {


        const {
            percentage
        } = this.state;

        let list = [];
        if(this.props.SchoolStore.lessonSelected !== null){
            list = this.props.SchoolStore.students.map(
                // list = testString.map(
                student => {

                    let replacement = '';
                    if(student.replacement){
                        replacement = <div className="preparation replacement">(Replacement)</div>;
                    }

                    let preparation = '';
                    if ( student.preparation !== 0 && student.preparation !== '') {
                        preparation = <div className="preparation">Preparation: {student.preparation}% done</div>;
                    }

                    let attendence = '';

                    if ( student.attendance !== undefined ) {
                        attendence = <div className="status-attendence"><strong>Comparecimento: {student.attendance}</strong></div>
                    }

                    let classname = "name";

                    if( student.isClass === 1) {
                        classname = "name2";
                    }

                    return (
                        <div className="student" key={student.cpf}>
                            <div className="photo" style={{backgroundImage: `url(${student.photo})`}}/>
                            <div className="infos">
                                {attendence}
                                <div className={classname}>{student.firstName} {student.lastName}</div>
                                {replacement}
                                {/* <div className="school-name">Aula: {student.level}</div> */}
                                {preparation}
                                <div className="buttons-attendance">
                                    <button onClick={this.handleClickCheckAttendance.bind(this, student.id, student.unitIdSf)} disabled={student.attendance === "present" || student.attendance === "late" ? true : false}>Registro de presença</button>
                                    <button onClick={this.handleClickStudent.bind(this, student.cpf)}>Mais</button>
                                </div>
                            </div>

                        </div>
                    )
                }
            );
        }

        let groupProgress = '';

        if ( this.props.SchoolStore.groupProgress !== 0 ) {
            groupProgress = this.props.SchoolStore.groupProgress+'% done';
        }

        return (
            <div className="ClassReport Page">
                <div className="container">
                    <div className="header-section">
                        <h1>Registrar Presença</h1>
                        <Breadcrumb segments={ClassReport.breadcrumbSegments}
                            onClick={this.handleBreadcrumbClick.bind(this)}/>
                    </div>

                    <QrCodeModal ref={ref => (this.qrModalRef = ref)} />


                    
                    <div className="dropdowns">
                    <div className="DropdownFilter qr-wrapper">
                        <DropdownSchool />
                        <DropdownClass />
                        <DropdownLesson />

                        <button
                            className="btn-generate-qrcode"
                            onClick={() => this.handleGenerateQRCode()}
                            disabled={
                            !this.props.SchoolStore.schoolSelected ||
                            !this.props.SchoolStore.classSelected ||
                            !this.props.SchoolStore.lessonSelected
                            }
                        >
                            Gerar QR Code
                        </button>
                    </div>

                        <h3 className="error-msg-attendance">{this.props.SchoolStore.msgAttendance}</h3>
                        {this.props.SchoolStore.classesLoadError && (
                            <p className="classes-load-error">{this.props.SchoolStore.classesLoadError}</p>
                        )}
                    </div>
                    <div className="contents">
                        <List counter={list.length}
                              messageEmpty={'Selecione uma unidade, turma e aula para visualizar a lista de alunos.'}
                              loader={this.props.SchoolStore.isLoading}>
                            {list}
                        </List>
                    </div>
                </div>
            </div>
        )

    }

}


// WEBPACK FOOTER //
// ./src/containers/ClassReport.js